import { fluid } from '@helpers/fluid';
import { h5, paragraph } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const Inner = styled.div `
  background-color: var(--widgetThemeColorLight);
  border-radius: ${fluid(25, 50)};
  padding: ${fluid(30, 75)} ${fluid(30, 60)};
`;
const TopArea = styled.div `
  margin-bottom: ${fluid(30, 50)};
`;
const Title = styled.h2 `
  ${h5};
`;
const Summary = styled.p `
  ${paragraph};
  margin: 0;
`;
const Wrapper = styled.div `
  &[data-remove-location='true'] .zrsite_Location,
  &[data-remove-date-opened='true'] .zrsite_Date_Opened,
  &[data-remove-job-type='true'] .zrsite_Job_Type,
  &[data-remove-job-description='true'] .zrsite_Job_Description {
    display: none !important;
  }

  .embed_jobs_head2 {
    width: 100%;
  }

  .zr_fillayout_info {
    flex: 1 0 70%;
  }
`;
export const ZohoRecruitEmbedStyles = {
    Container,
    Inner,
    TopArea,
    Title,
    Summary,
    Wrapper,
};
